import { useTranslation } from "react-i18next";
import { FlexCol } from "../Flex/FlexCol";
import { DivisorX } from "../Outros/DivisorX";
import { LinkX } from "../Outros/LinkX";
import { TX } from "../Tags/TextoX";

export const Footer = () => {
  const { t: tradutor } = useTranslation();
  const t = (t: string) => tradutor(`footer.${t}`);

  return (
    <footer className="bg-white">
      <div className="content-area pt-16 md:pt-[7.1875rem] lg:px-5">
        <div className="grid justify-center lg:grid-cols-[auto,auto,auto,auto] lg:justify-between">
          <div className="grid">
            <a href="#" title="Santana Cred" rel="follow">
              <img
                src="/projeto/logo.webp"
                alt="logo"
                className={`
              h-[86.35px]
              w-[47.98]
          `}
              />
            </a>
            <p className="body-text-3 mb-32 mt-6 text-black">
              Há 16 anos no mercado, nossa missão é transformar <br className="inline-block" />{" "}
              qualidade em <strong>resultados</strong>
              , ajudando ao máximo nossos
              <br className="inline-block" />
              clientes a alcançarem<strong> o sucesso financeiro</strong>.
            </p>
            <div className="border-t border-black py-6"></div>
            <p className="cap-2 mb-6 text-20 text-black">Nossas Redes Sociais</p>
            <ul className="flex items-center gap-11 pb-7 lg:pb-0">
              <li>
                <a
                  href="https://www.facebook.com/santanacredi"
                  rel="nofollow noreferrer"
                  title="Siganos no Facebook"
                  target="_blank"
                >
                  <img src="/projeto/facebook.png" alt="símbolo do facebook" className="h-8 w-8" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/santanacredudi/"
                  rel="nofollow noreferrer"
                  title="Siganos no Instagram"
                  target="_blank"
                >
                  <img src="/projeto/instagram.png" alt="símbolo do facebook" className="h-8 w-8" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@santanacredudi?_t=8fc38xM8Tgb&_r=1"
                  rel="nofollow noreferrer"
                  title="Siganos no TikTok"
                  target="_blank"
                >
                  <img src="/projeto/tiktok.png" alt="símbolo do facebook" className="h-8 w-8" />
                </a>
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <ul className="pb-7 text-black lg:pb-0">
              <li className="cap-2 mb-5 text-20">Serviços</li>
              <a href="https://www.santanacred.com.br/saquefgts1">
                <li className="mb-4 hover:underline">FGTS</li>
              </a>
              <a href="https://www.santanacred.com.br/inss1">
                <li className="mb-4 hover:underline">CréditoConsignado</li>
              </a>
              <a href="https://www.santanacred.com.br/inss1">
                <li className="mb-4 hover:underline">Portabilidade</li>
              </a>
              <a href="https://www.santanacred.com.br/inss1">
                <li className="mb-4 hover:underline">Cartão de Crédito Consig.</li>
              </a>
            </ul>
          </div>
          <div className="grid gap-3">
            <ul className="text-black">
              <li className="cap-2 mb-5 text-20">contato</li>
              <li className="mb-4">
                <a
                  href="mailto:sac@santanacredi.com.br"
                  className="body-text-2 group group flex items-center"
                  rel="follow noreferrer"
                  target="_blank"
                  title="sac@santanacredi.com.br"
                >
                  <svg
                    width="15"
                    height="17"
                    viewBox="0 0 15 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.41666 1.61743C4.10477 1.61743 1.5 4.1228 1.5 7.09743C1.5 10.0789 3.58939 12.468 6.62049 12.6184C7.01977 12.6382 7.33333 12.9677 7.33333 13.3674V14.6683C8.74114 13.9337 10.0972 13.0184 11.163 11.9244C12.4882 10.5641 13.3333 8.96328 13.3333 7.09743C13.3333 4.12279 10.7286 1.61743 7.41666 1.61743ZM0 7.09743C0 3.2004 3.37355 0.117432 7.41666 0.117432C11.4598 0.117432 14.8333 3.20041 14.8333 7.09743C14.8333 9.46078 13.7509 11.4175 12.2374 12.9711C10.7304 14.518 8.76549 15.7003 6.8934 16.5503C6.66127 16.6557 6.39148 16.636 6.17716 16.4979C5.96284 16.3599 5.83333 16.1224 5.83333 15.8674V14.047C2.33484 13.5337 0 10.5842 0 7.09743Z"
                      fill="#1658A6"
                    ></path>
                  </svg>
                  <span className="ml-6 transition-all ease-linear group-hover:text-primaria-claro">
                    sac@santanacredi.com.br
                  </span>
                </a>
              </li>
              <li className="mb-4">
                <a
                  href="tel:08000420324"
                  className="body-text-2 group flex items-center"
                  rel="follow noreferrer"
                  target="_blank"
                  title="Ligue agora 0800 042 0324"
                >
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.98445 9.35784C6.00945 8.38285 5.27445 7.29118 4.78612 6.18368C4.68279 5.94951 4.74362 5.67535 4.92445 5.49451L5.60695 4.81285C6.16612 4.25368 6.16612 3.46285 5.67779 2.97451L4.69945 1.99618C4.04862 1.34535 2.99362 1.34535 2.34279 1.99618L1.79945 2.53951C1.18195 3.15701 0.924449 4.04785 1.09112 4.93118C1.50279 7.10868 2.76779 9.49284 4.80862 11.5336C6.84945 13.5745 9.23359 14.8395 11.4111 15.2511C12.2945 15.4178 13.1853 15.1603 13.8028 14.5428L14.3453 14.0003C14.9961 13.3495 14.9961 12.2945 14.3453 11.6436L13.3678 10.6661C12.8795 10.1778 12.0878 10.1778 11.6003 10.6661L10.8478 11.4195C10.667 11.6003 10.3928 11.6611 10.1586 11.5578C9.05109 11.0686 7.95949 10.3328 6.98445 9.35784Z"
                      stroke="#1658A6"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span className="ml-6 transition-all ease-linear group-hover:text-primaria-claro">
                    0800 042 0324
                  </span>
                </a>
              </li>
              <li className="mb-4">
                <a
                  href="https://wa.me/message/EUFVJ4POPJJPK1"
                  className="body-text-2 group flex items-center pb-7 lg:pb-0"
                  rel="nofollow noreferrer"
                  target="_blank"
                  title="Ligue agora (34) 3225-9969"
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.94249 10.2004C8.57999 11.8387 10.6542 12.882 11.8883 11.6537L12.1875 11.3545C12.5867 10.9562 12.5308 10.2962 12.0675 9.97446C11.7758 9.77116 11.4625 9.55286 11.1158 9.30946C10.7575 9.05786 10.2658 9.09696 9.955 9.40536L9.6167 9.74116C9.1975 9.47536 8.7825 9.13446 8.39749 8.74946L8.39582 8.74786C8.01082 8.36282 7.66999 7.94782 7.40415 7.52865L7.73999 7.19032C8.04915 6.87949 8.08749 6.38782 7.83582 6.02949C7.59165 5.68282 7.37332 5.36949 7.17082 5.07782C6.84915 4.61532 6.18915 4.55949 5.79082 4.95782L5.49166 5.25699C4.26332 6.49115 5.30666 8.56446 6.94415 10.2029M13.8739 3.24303C12.5022 1.87053 10.6781 1.11387 8.73471 1.11304C4.7289 1.11304 1.46974 4.37053 1.4689 8.3747C1.46724 9.64886 1.8014 10.9014 2.43807 12.0056L1.40723 15.7689L5.2589 14.7589C6.32474 15.3389 7.51807 15.6431 8.73141 15.6431H8.73471C12.7389 15.6431 15.9981 12.3847 15.9997 8.38053C16.0006 6.44053 15.2456 4.61637 13.8739 3.24303Z"
                      stroke="#1658A6"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span className="ml-6 transition-all ease-linear group-hover:text-primaria-claro">
                    (34) 3225-9969
                  </span>
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/553432259969"
                  className="animate-grow-and-shrink bg-green-wpp-light group flex items-center justify-center rounded-3 bg-green-600 p-3 text-16 font-bold leading-24 duration-200 hover:bg-green-800 sm:text-20 "
                  rel="nofollow noreferrer"
                  target="_blank"
                  title="Envie Mensagem agora (34) 3225-9969"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.94249 10.2004C8.57999 11.8387 10.6542 12.882 11.8883 11.6537L12.1875 11.3545C12.5867 10.9562 12.5308 10.2962 12.0675 9.97446C11.7758 9.77116 11.4625 9.55286 11.1158 9.30946C10.7575 9.05786 10.2658 9.09696 9.955 9.40536L9.6167 9.74116C9.1975 9.47536 8.7825 9.13446 8.39749 8.74946L8.39582 8.74786C8.01082 8.36282 7.66999 7.94782 7.40415 7.52865L7.73999 7.19032C8.04915 6.87949 8.08749 6.38782 7.83582 6.02949C7.59165 5.68282 7.37332 5.36949 7.17082 5.07782C6.84915 4.61532 6.18915 4.55949 5.79082 4.95782L5.49166 5.25699C4.26332 6.49115 5.30666 8.56446 6.94415 10.2029M13.8739 3.24303C12.5022 1.87053 10.6781 1.11387 8.73471 1.11304C4.7289 1.11304 1.46974 4.37053 1.4689 8.3747C1.46724 9.64886 1.8014 10.9014 2.43807 12.0056L1.40723 15.7689L5.2589 14.7589C6.32474 15.3389 7.51807 15.6431 8.73141 15.6431H8.73471C12.7389 15.6431 15.9981 12.3847 15.9997 8.38053C16.0006 6.44053 15.2456 4.61637 13.8739 3.24303Z"
                      stroke="#fff"
                    ></path>
                  </svg>
                  <span className="ml-3 text-white transition-all ease-linear">
                    Solicite Agora!
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="body-text-3 mt-40 grid gap-8 border-t border-black px-4 py-6 text-black md:justify-center md:gap-4 md:px-0 lg:flex lg:justify-between lg:gap-0">
          <ul className="flex flex-1 items-center justify-between gap-9 px-3 sm:px-0 lg:justify-end">
            <li>
              <a
                className="font-semibold transition-all ease-linear hover:text-primaria-claro"
                href="/politica"
                rel="nofollow"
                title="Políticas de Privacidade"
              >
                Políticas de Privacidade
              </a>
            </li>
            <li>
              <a
                className="font-semibold transition-all ease-linear hover:text-primaria-claro"
                href="/termos"
                rel="nofollow"
                title="Termo de Uso"
              >
                Termo de Uso
              </a>
            </li>
          </ul>
        </div>
        <div className="mb-1.5 flex flex-col px-7 text-xs text-black lg:px-0 ">
          <p className="text-justify">
            {" "}
            A Santana Cred Serviços Ltda é uma prestadora de serviços autorizada do BANCO MERCANTIL
            DO BRASIL SA CNPJ 17.184.037/0001-10 e não realiza operações de crédito diretamente. A
            Santana Cred é uma plataforma digital que atua como correspondente bancário para
            facilitar o processo de contratação de empréstimos. Como correspondente bancário,
            seguimos as diretrizes do Banco Central do Brasil, nos termos da Resolução nº. 3.954, de
            24 de fevereiro de 2011. Toda avaliação de crédito será realizada conforme a política de
            crédito da Instituição Financeira escolhida pelo usuário. Antes da contratação de
            qualquer serviço através de nossos parceiros, você receberá todas as condições e
            informações relativas ao produto a ser contrato, de forma completa e transparente. As
            taxas de juros,margem consignável e prazo de pagamento praticados nos empréstimos com
            consignação em pagamento dos Governos Federais, Estaduais e Municipais, Forças armadas e
            INSS observam as determinações de cada convênio, bem como a política de crédito da
            instituição financeira a ser utilizada.{" "}
          </p>
          <p className="text-left">
            {" "}
            SANTANA CRED SERVIÇOS LTDA – CNPJ 11.003.397/0001-91 e SWX CRED EIRELI – CNPJ
            27.101.349/0001-76 | Endereço: Rua Cruzeiro dos Peixotos, 444 – Bairro Centro, Cidade de
            Uberlandia – MG CEP 38400.107 | E-mail para contato: sac@santanacredi.com.br
          </p>
        </div>
      </div>
      <FlexCol className="w-full items-center px-5">
        <DivisorX />
        <TX tipo="p" className="text-10 font-semibold text-black">
          © {t("direitoAutoral")} {new Date().getFullYear()}. {t("feitoPor")}{" "}
          <LinkX rota="https://github.com/tianopo" target="blank">
            tianopo
          </LinkX>
        </TX>
      </FlexCol>
    </footer>
  );
};
